<template>
  
  
  <header>

    
    
    
      <img style="width: 100%; height: 10%" alt="$FEVO" src="./assets/1500x500.jpg">
    

  
  
     
    
  
    

        
  <div class="menu_box">
    <a href="#stakev2" class="button-42">Stake V2</a>
    <a href="#burn" class="button-42">FEVO BURN</a>
    <a href="#about" class="button-42">About</a>
    <a href="#FEVO" class="button-42">$FEVO</a>
    <a href="#exchanges" class="button-42">Exchanges</a>
    <a href="#faucet" class="button-42">Giveaway</a>
    <a href="#wallet" class="button-42">Metamask</a>
    <a href="#whitepaper" class="button-42">White Paper</a>
    <a href="#discord" class="button-42">Discord</a>
    <a href="#playgame" class="button-42">Play Game</a>
    <a href="#twitter" class="button-42">Tweets</a>
    <a href="#stake" class="button-42">Stake (old)</a>    
    
  </div>  

  
  </header>
  
  
  <MainPage msg=""/>
  <UserWallet msg="Connected Wallet"/>
  <SignUp msg="Autnticate"/>

  
  <footer >
  <div class="menu_box">

    <img style="width: 10%; height: 10%" alt="$FEVO" src="./assets/logo.png">    
    <p>2026 Flappy Bird Evolution - FEVO</p>


    <a href="https://twitter.com/flapbirdevo" target="_blank">
      <img src="./assets/twitter_icon.png" alt="Twitter Icon" width="40" height="40" style="margin-right: 10px;">
    </a>
    <a href="https://discord.gg/99MEJRRXrj" target="_blank">
      <img src="./assets/discord_icon.png" alt="Discord Icon" width="40" height="40" style="margin-right: 10px;">
    </a>
    <a href="mailto:flapbirdevolution@gmail.com">
      <img src="./assets/email_icon.png" alt="Email Icon" width="40" height="40">
    </a>

  </div>
</footer>



<!--  <a href="https://twitter.com/endless_fish">
    <img alt="Vue logo" src="./assets/downbar.png">
  </a>
  -->



</template>

<script>
import SignUp from './components/SignUp.vue';
import MainPage from './components/About.vue'



export default {
  mounted() {
   
  },
  name: 'App',
  data() {}
        ,methods:{
    }
     ,
  components: {
    SignUp,
    MainPage
    
}
}
</script>

<style>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ababab;
  background-image: linear-gradient(-180deg, #5B35A5, #71C5D0);
  
  margin-top: 00px;
  margin-left: 0%;
  margin-right: 0%;
  width: auto;
}

.parent {
  position: relative;
  top: 0;
  left: 0;
}
.image1 {
  position: relative;
  top: 0;
  left: 0;
  border: 0px red solid;
}
.image2 {
  position: absolute;
  top: 01px;
  left: 20px;
  border: 0px green solid;
  width: 12%;
  height: 23%;
}
.image3 {
  position: relative;
  top: 10px;
  left: 10px;
  border: 0px green solid;
  width: 100%;
  height: 21%;
}
.image4 {
  position: absolute;
  top: 28px;
  left: 160px;
  border: 0px green solid;
  
}
.image5 {
  position: absolute;
  top: 30px;
  left: 485px;
  border: 0px green solid;
  
}

.box {
  width: 100%;
  height: 30%;
  background-color: white;
}

.header {   

position: sticky;   

top: 0; 

}



header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
    position: fixed;
  }

  nav {
    text-align: left;
    margin-left: -1rem;
    font-size: 1rem;

    padding: 1rem 0;
    margin-top: 1rem;
  }


  nav {
  width: 100%;
  font-size: 12px;
  text-align: center;
  margin-top: 2rem;
}

nav a.router-link-exact-active {
  color: var(--color-text);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}

.button-36 {
  background-image: linear-gradient(92.88deg, #914B9D 9.16%, #71C5D0 43.89%, #914B9D 64.72%);
  border-radius: 8px;
  border-style: none;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  flex-shrink: 0;
  font-family: "Inter UI","SF Pro Display",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Open Sans","Helvetica Neue",sans-serif;
  font-size: 16px;
  font-weight: 500;
  height: 4rem;
  padding: 0 1.6rem;
  text-align: center;
  text-shadow: rgba(0, 0, 0, 0.25) 0 3px 8px;
  transition: all .5s;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  display: inline-flex;
  align-items: center; 
}

.menu_box {
	border-radius: 0.0rem;
  background-color:rgba(109, 109, 152, 0.5);
  border-color:transparent;
  border: 0.0000rem;
  width: 100%;
  margin-right: 260px;
  margin-top: -10px;
  margin-bottom: 3px;
  display: inline-table;
  font-size: medium;
  font-family: Georgia, 'Times New Roman', Times, serif;
  transition: all 0.8s;
  text-align: center;
  border-style: solid;
  padding-top: 2px;
  padding-bottom: 2px;
}

.footer_box {
	border-radius: 0.0rem;
  background-color:rgba(109, 109, 152, 0.5);
  border-color:rgba(109, 109, 152, 0.5);
  border: 0.0005rem;
  width: 100%;
  margin-right: 260px;
  margin-top: -10px;
  margin-bottom: 3px;
  display: inline-table;
  font-size: medium;
  font-family: Georgia, 'Times New Roman', Times, serif;
  transition: all 0.3s;
  text-align: center;
  border-style: solid;
  padding-top: 2px;
  padding-bottom: 2px;
  user-select: none;
  -webkit-user-select: none;
}


.div_box {
	margin:  auto;
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  border-color:rgba(185, 185, 193, 0.5);
  background-color:rgba(30, 30, 31, 0.5);
  border: 0.00rem;
  width: 80%;
  
  margin-top: 30px;
  display: inline-table;
  font-size: 17px;
  font-family: 'Courier New', Courier, monospace;
  transition: all 0.3s;
  text-align: center;
  border-style: solid;
}

.div_box2 {
	
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  border-color:rgba(185, 185, 193, 0.5);
  border: 0.05rem;
  width: 80%;
  margin: 20px;
  margin-top: 30px;
  display: inline-table;
  font-size: medium;
  transition: all 0.3s;
  
  
  border-style: solid;
}

.div_box_menu {
	
  padding: 1.5rem 2rem;
  border-radius: 0.4rem;
  border-color:rgba(185, 185, 193, 0.5);
  border: 0.05rem;
  width: 100%;
  display: inline-table;
  font-size: medium;
  transition: all 0.3s;
  
  
  border-style: solid;
}


.abutton {
    -webkit-appearance: button;
    -moz-appearance: button;
    appearance: button;

    text-decoration: none;
    color: initial;
}


.button-42 {
  background-color: initial;
  background-image: linear-gradient(-180deg, #570b64, #905d99);
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-block;
  font-family: Inter,-apple-system,system-ui,Roboto,"Helvetica Neue",Arial,sans-serif;
  height: 40px;
  line-height: 40px;
  outline: 0;
  overflow: hidden;
  
  margin-left: 10px;
  pointer-events: auto;
  position: relative;
  text-align: center;
  touch-action: manipulation;
  user-select: none;
  -webkit-user-select: none;
  vertical-align: top;
  white-space: nowrap;
  width: 100px;
  z-index: 9;
  border: 0;
  transition: box-shadow .2s;
  text-decoration:none;
  display: inline-block; 
  justify-content: flex-end;
}

.button-42:hover {
  box-shadow: rgba(113, 197, 208, 0.9) 0 6px 10px;
}



::-webkit-scrollbar {
  width: 08px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey; 
  width: 0px;
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: gray; 
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: gray; 
  height: 08px;
}
</style>
